import { render, staticRenderFns } from "./SignSupervisorAdd.vue?vue&type=template&id=96114af8&scoped=true&"
import script from "./SignSupervisorAdd.vue?vue&type=script&lang=js&"
export * from "./SignSupervisorAdd.vue?vue&type=script&lang=js&"
import style0 from "./SignSupervisorAdd.vue?vue&type=style&index=0&id=96114af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96114af8",
  null
  
)

export default component.exports